import { createTheme } from "@mui/material/styles";

export const muiTheme = createTheme({
  palette: {
    primary: {
      main: "#F47C20",
    },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiInputBase-root": {
            height: 40,
            padding: "0 8px",
            borderRadius: "8px",
            fontSize: "14px",
          },
          "& input": {
            fontSize: "14px",
          },
        },
      },
    },

    MuiPickersLayout: {
      styleOverrides: {
        root: {
          borderRadius: "12px",
          border: "1px solid #ddd",
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        },
      },
    },

    MuiPickersArrowSwitcher: {
      styleOverrides: {
        button: {
          color: "#F47C20",
        },
      },
    },

    MuiPickersDay: {
      styleOverrides: {
        root: {
          fontSize: "14px",
          borderRadius: "8px",
        },
        today: {
          border: "1px solid #F47C20",
        },
        selected: {
          backgroundColor: "#F47C20 !important",
          color: "#fff !important",
        },
      },
    },

    // MuiMultiSectionDigitalClock: {
    //   styleOverrides: {
    //     root: {
    //       width: 150,
    //     },
    //   },
    // },

    MuiMultiSectionDigitalClockSectionItem: {
      styleOverrides: {
        root: {
          fontSize: "14px",
        },
        selected: {
          backgroundColor: "#F47C20 !important",
          color: "#fff !important",
          borderRadius: "6px",
        },
      },
    },

    MuiClockPointer: {
      styleOverrides: {
        thumb: {
          backgroundColor: "#F47C20",
          borderColor: "#F47C20",
        },
        pointer: {
          backgroundColor: "#F47C20",
        },
      },
    },

    MuiPickersClockNumber: {
      styleOverrides: {
        selected: {
          backgroundColor: "#F47C20 !important",
          color: "#fff !important",
        },
      },
    },

    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: "8px 16px",
          "& .MuiButton-root": {
            fontWeight: 600,
          },
          "& .MuiButton-textPrimary": {
            color: "#F47C20",
          },
        },
      },
    },
  },
});
